import { render, staticRenderFns } from "./TechProvider.vue?vue&type=template&id=37e3e11d&"
import script from "./TechProvider.vue?vue&type=script&lang=js&"
export * from "./TechProvider.vue?vue&type=script&lang=js&"
import style0 from "./TechProvider.vue?vue&type=style&index=0&id=37e3e11d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports